import { useState } from 'react';
import { IonButton, IonSpinner } from '@ionic/react';
import { createUseStyles } from 'react-jss';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { AlertPresenter } from '../../AlertBinder';
import { ITrackingFrom } from '../ITrackingFrom';
import { SHARING_ACTION_BUTTON_MIN_WIDTH } from '../sharingActionButton';
import { CareCodeService } from './CareCodeService';

const useStyles = createUseStyles({
    button: {
        minWidth: SHARING_ACTION_BUTTON_MIN_WIDTH
    }
});

export const CreateCareCodeButton: React.FC<{ trackingFrom: ITrackingFrom; }> = ({ trackingFrom }) => {
    const classes = useStyles();

    const careCodeService = useInstance(CareCodeService);
    const alert = useInstance(AlertPresenter);

    const [isCreating, setIsCreating] = useState(false);

    const createCareCode = async () => {
        setIsCreating(true);
        try {
            await careCodeService.createAndOpen({ from: trackingFrom });
        } catch (err: any) {
            alert.showAndLogError(err);
        } finally {
            setIsCreating(false);
        }
    };

    return (
        <IonButton
            fill="outline"
            size="small"
            className={classes.button}
            disabled={isCreating}
            onClick={createCareCode}
            data-id="create-care-code-btn"
        >
            {isCreating ? <IonSpinner name="dots" /> : '+ Create QR Code'}
        </IonButton>
    );
};
